import { enumWrapTextMode } from "../constants";

export function ConvertWrapTextSelection(aCmd) {
  var v = enumWrapTextMode.nowrap;
  var index = aCmd["newvalue"];
  switch (index) {
    case "oneline":
      v = enumWrapTextMode.oneline;
      break;
    case "twolines":
      v = enumWrapTextMode.twolines;
      break;
    case "threelines":
      v = enumWrapTextMode.threelines;
      break;
    case "fourlines":
      v = enumWrapTextMode.fourlines;
      break;
    case "unlimited":
      v = enumWrapTextMode.unlimited;
      break;
  }

  return v;
}
